import { render, staticRenderFns } from "./questionnaireDetail.vue?vue&type=template&id=2d8c9abe&scoped=true"
import script from "./questionnaireDetail.vue?vue&type=script&lang=js"
export * from "./questionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./questionnaireDetail.vue?vue&type=style&index=0&id=2d8c9abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c9abe",
  null
  
)

export default component.exports